/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EventoTipoPratica } from './evento-tipo-pratica';
import { PraticaEventoPayload } from './pratica-evento-payload';
import { CanaleComunicazione } from './canale-comunicazione';


export interface ComunicazionePayload extends PraticaEventoPayload { 
    canale?: CanaleComunicazione;
    evento?: EventoTipoPratica;
    esito?: string;
    errore_codice?: string;
}



